import * as React from 'react';

import { Button, ButtonProps } from '../../../figma/ButtonV2/ButtonV2';
import { Typography } from '../../../figma/DesignSystemV2/Typography';
import { Link } from '../../../figma/Link';

interface PageObjectContentProps {
  title: string;
  description: string;
  url?: string;
  actionText?: string;
  actionProps?: ButtonProps;
}

export const PageObjectContent = (props: PageObjectContentProps) => {
  const { title, description, url, actionText = 'Tìm hiểu thêm', actionProps } = props;

  return (
    <div className={'pageObjectContent'}>
      <div className={'info'}>
        <Typography.Title level={3} variant="semi-bold/20">
          {title}
        </Typography.Title>
        <Typography.Paragraph variant="regular/16" color="black70">
          {description}
        </Typography.Paragraph>
      </div>
      {url && (
        <Link href={url}>
          <Button.Primary size="small" {...actionProps}>
            {actionText}
          </Button.Primary>
        </Link>
      )}
    </div>
  );
};
